<template>
  <div data-component="base-settings">
    <base-settings-menu-sidebar
      :menu-groups="menuGroups"
      :active-menu-item-id="activeMenuItemId"
      @item-click="activeMenuItemId = $event"
    />

    <div class="content-area">
      <slot :active-menu-item-id="activeMenuItemId" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { MenuItemGroup } from '../types';
import BaseSettingsMenuSidebar from './BaseSettingsMenuSidebar.vue';

export default defineComponent({
  name: 'BaseSettings',
  components: { BaseSettingsMenuSidebar },
  props: {
    menuGroups: {
      type: Array as PropType<MenuItemGroup[]>,
      default: () => [],
    },
    defaultMenuItemId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeMenuItemId: this.defaultMenuItemId,
    };
  },
});
</script>

<style lang="scss" scoped>
[data-component='base-settings'] {
  display: flex;
  height: 100%;
  color: var(--or-c-on-background);
  overflow: hidden;

  .content-area {
    flex: 1 1 100%;
    overflow: hidden;
    background: var(--or-c-surface-1);
  }
}
</style>
